module.exports = __webpack_public_path__ + "img/ico_product_quantity_minus.c474d544.svg";